<template>
        <div class="">
            <h1 class="text-muted mb-4">
                <vue-fontawesome class="mr-2" icon="map-marker"></vue-fontawesome>
                Locations
            </h1>
            <!-- list locations -->
            <section>
                <div class="d-flex justify-content-between">
                    <div>
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" 
                                    id="pills-home-tab" 
                                    data-toggle="pill" 
                                    href="#pills-home" 
                                    role="tab" 
                                    aria-controls="pills-home" 
                                    aria-selected="true">
                                                            
                                    Locations
                                </a>
                            </li>                               							
                        </ul>
                    </div>               
                </div>	
    
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab">
                    <div class="mb-4 d-flex justify-content-between p-2">
                        <!-- right -->
                        <section class="d-flex">
                            <span class="p-2 font-weight-bold" v-if="locations">
                                <span class="text-muted">Found</span> {{locations.length}}
                            </span>
                            <div class="dropdown">
                                <a class="btn btn-light dropdown-toggle" 
                                    href="#" role="button" id="dropdownMenuLink" 
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Filters
                                </a>
                                
                                <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                        <div class="form-group d-flex justify-content-between">
                                            <label class="p-2">Search</label>
                                            <input type="text" class="col-8 form-control" v-model="search"> 
                                        </div> 												                                   
                                        <div class="ml-2 d-flex justify-content-end">
                                            <button class="btn btn-outline-success"  @click="getLocations()">
                                                Get locations
                                            </button>
                                        </div>	
                                </div>
                            </div>
                            <div class="ml-2">
                                <button class="d-none btn btn-outline-success">Export to CSV</button>	
                            </div>	
                        </section>  
                        <!-- add buttons -->
                        <section>
                            <button  type="button" class="btn btn-success" data-toggle="modal" data-target="#addLocationModal"
                                >
                                Add location
                            </button>
                        </section>             																							
                    </div>         
                    <!-- LOCATIONS TABLE AND DEPENDENCIES -->
                    <div class="rounded shadow border border-light p-2">
                        <table class="table table-borderless table-responsive-sm">
                                <thead >
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Address</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Type</th>                        
                                        <th scope="col"></th>   
                                    </tr>
                                </thead>                    
                                <tbody v-if="locations && locations.length">
                                    <tr v-for="(location,index) in locations" :key="index">
                                        <td>{{location.name}}</td>
                                        <td>{{location.address}}</td>
                                        <td>{{location.phone}}</td>
                                        <td>{{location.email}}</td>
                                        <td>{{location.type}}</td>
                                        <td>
                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Actions
                                            </a>                                                                                                                            
                                            <span class="dropdown-menu">                                        
                                                <a  type="button" class="cursor-pointer dropdown-item" data-toggle="modal" data-target="#editLocationModal"
                                                    @click="selectLocation(location)">
                                                    edit location
                                                </a>
                                                <a class="cursor-pointer dropdown-item" @click="deleteLocation(location)">remove</a>
                                            </span>										                                                                            
                                        </td>   
                                    </tr>                       
                                </tbody>
                        </table>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="locations && ! locations.length">
                            No records to show
                        </div>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="! locations">
                            <div class="spinner-border p-3 m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>        
            <!-- add location -->
            <section>                                                
                <div class="modal fade" id="addLocationModal" tabindex="-1" role="dialog" aria-labelledby="addLocationModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Add location</h5>
                        <button type="button" id="closeaddLocationModal" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="addLocationForm">
                        <div class="modal-body">                    
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">name</label>
                                <input type="text" class="col-8 form-control" v-model="location_to_add.name" required>
                            </div>                    
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">email</label>
                                <input type="email" class="col-8 form-control" v-model="location_to_add.email">
                            </div>                                                        
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">phone</label>
                                <input  type="text" minlength="10" maxlength="10" class="col-8 form-control" v-model="location_to_add.phone" required/>
                            </div>
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">address</label>
                                <input type="text" class="col-8 form-control" v-model="location_to_add.address" required>
                            </div>
                            <div class="p-3 d-flex justify-content-between">
                                <label class="font-weight-bold">type</label>                                
                                <select class="col-8 form-control" aria-label="Default select example" v-model="location_to_add.type">                                                                                                         
                                    <option selected value="shop">shop</option>
                                    <option value="store">store</option>                                    
                                  </select>
                            </div>
                        </div>
                        <div class="modal-footer">                            
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success"
                                @click="addLocation()">                                                        
                                Add location
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
                            </button>
                        </div>
                    </form>                
                    </div>
                </div>
                </div>
            </section>
            <!-- edit location. -->
            <section>
                <div class="modal fade" id="editLocationModal" tabindex="-1" role="dialog" aria-labelledby="editLocationModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document" v-if="location">
                        <div class="modal-content">
                        <div class="modal-header border-0">
                            <h5 class="modal-title" id="exampleModalCenterTitle">{{location.name}}</h5>
                            <button type="button" id="closeeditLocationModal" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form id="editCustomerForm">
                            <div class="modal-body">                    
									<div class="p-3 d-flex justify-content-between">
										<label class="font-weight-bold">name</label>
										<input type="text" class="col-8 form-control" v-model="location.name" required>
									</div>                    
									<div class="p-3 d-flex justify-content-between">
										<label class="font-weight-bold">email</label>
										<input type="email" class="col-8 form-control" v-model="location.email">
									</div>                                                        
									<div class="p-3 d-flex justify-content-between">
										<label class="font-weight-bold">phone</label>
										<input  type="text" minlength="10" maxlength="10" class="col-8 form-control" v-model="location.phone" required/>
									</div>
									<div class="p-3 d-flex justify-content-between">
										<label class="font-weight-bold">address</label>
										<input type="text" class="col-8 form-control" v-model="location.address" required>
									</div>
									<div class="p-3 d-flex justify-content-between">
										<label class="font-weight-bold">type</label>
										<input type="text" class="col-8 form-control" v-model="location.type" required>
									</div>
                            </div>
                            <div class="modal-footer border-0">                            
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-success"
                                    @click="editLocation()">                                                        
                                    Edit location
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="adding"></span>
                                </button>
                            </div>
                        </form>                
                        </div>
                    </div>
                    </div>
            </section>
        </div>
    </template>
    <script>
    export default {
        name: 'locations',
        props: {
            msg: String
        },
        data(){
            return{
                locations:null,
                //selected location
                location: null,                            
                //add expense
                location_to_add:{},
                adding : false,            
            }
        },
        mounted(){        
            this.getLocations()              
        },
        account_switched: function(){
            this.getLocations()
        }, 
        methods:{		
            //get_locations
            getLocations: function(){                        
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },            
                }).then((response)=>{
                    this.locations = response.data
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            // select location to edit or view
            selectLocation: function(location){
                this.location = location
            },
            //add expense.
            addLocation: function(){
                var is_valid = document.getElementById('addLocationForm').checkValidity()
                if(is_valid){
                    this.adding = true
                    this.location_to_add.id = this.$randID()                    
                    this.$http({
                        method:'post',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/location/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },   
                        data:this.location_to_add            
                    }).then(()=>{
                        this.adding = false
                        document.getElementById('closeaddLocationModal').click()
                        this.getLocations()
                    }).catch((err)=>{
                        this.adding = false
                        alert(err)
                    })                
                }
            },
            //edit location
            editLocation: function(){
                var is_valid = document.getElementById('editCustomerForm').checkValidity()
                if(is_valid){
                    this.adding = true
                    this.$http({
                        method:'patch',
                        url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/location/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },   
                        data:this.location
                    }).then(()=>{
                        this.adding = false
                        document.getElementById('closeeditLocationModal').click()
                        this.getLocations()
                    }).catch((err)=>{
                        this.adding = false
                        alert(err)
                    })                
                }
			},
			//delete
			deleteLocation: function(location){			
				var confirmed = confirm(`Do you want to delete location ${location.name} from system ?`);
				if (confirmed) {
					this.$http({
						method:'delete',				
						url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/location/${location.id}/`,
						headers:{
							Authorization: JSON.parse(localStorage.getItem('auth_token'))
						},            
					}).then(()=>{
						this.getLocations()
					}).catch((err)=>{
						alert(err)
					})
				}
			}
        }
    }
    </script>